"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioSelectCard = RadioSelectCard;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = require("../../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function RadioSelectCard(_ref) {
  var cardProps = _ref.cardProps,
      children = _ref.children,
      className = _ref.className,
      intent = _ref.intent,
      props = _objectWithoutProperties(_ref, ["cardProps", "children", "className", "intent"]);

  var classes = (0, _classnames.default)(_index.Classes.intentClass(intent), _index.Classes.CONTROL_SELECT_CARD, className);

  var controlCardProps = _objectSpread({
    paddingLevel: _index.PaddingLevel.REGULAR
  }, cardProps);

  return /*#__PURE__*/React.createElement(Control, _extends({}, props, {
    type: "radio",
    typeClassName: _index.Classes.RADIO,
    className: classes
  }), /*#__PURE__*/React.createElement(_index.Card, _extends({
    level: _index.CardLevel.NONE
  }, controlCardProps), children));
}
/**
 * This is all lifted pretty much straight out of Blueprint
 * It's needed as we need the underlying Control function as it's not exported
 */

/** Internal props for Checkbox/Radio/Switch to render correctly. */


function Control(_ref2) {
  var _classNames;

  var alignIndicator = _ref2.alignIndicator,
      children = _ref2.children,
      className = _ref2.className,
      indicatorChildren = _ref2.indicatorChildren,
      inline = _ref2.inline,
      inputRef = _ref2.inputRef,
      label = _ref2.label,
      labelElement = _ref2.labelElement,
      large = _ref2.large,
      style = _ref2.style,
      type = _ref2.type,
      typeClassName = _ref2.typeClassName,
      _ref2$tagName = _ref2.tagName,
      tagName = _ref2$tagName === void 0 ? 'label' : _ref2$tagName,
      htmlProps = _objectWithoutProperties(_ref2, ["alignIndicator", "children", "className", "indicatorChildren", "inline", "inputRef", "label", "labelElement", "large", "style", "type", "typeClassName", "tagName"]);

  var classes = (0, _classnames.default)(_index.Classes.CONTROL, typeClassName, (_classNames = {}, _defineProperty(_classNames, _index.Classes.DISABLED, htmlProps.disabled), _defineProperty(_classNames, _index.Classes.INLINE, inline), _defineProperty(_classNames, _index.Classes.LARGE, large), _classNames), _index.Classes.alignmentClass(alignIndicator), className);
  return /*#__PURE__*/React.createElement(tagName, {
    className: classes,
    style: style
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({}, htmlProps, {
    ref: inputRef,
    type: type
  })), /*#__PURE__*/React.createElement("div", {
    className: _index.Classes.CONTROL_FILL
  }), children, /*#__PURE__*/React.createElement("div", {
    className: _index.Classes.CONTROL_SELECT_CARD_CONTROL
  }, /*#__PURE__*/React.createElement("span", {
    className: _index.Classes.CONTROL_INDICATOR
  }, indicatorChildren), labelElement, label && /*#__PURE__*/React.createElement("span", {
    className: _index.Classes.CONTROL_LABEL
  }, label))));
}